import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import Player from '@vimeo/player';

@Component({
  selector: 'app-video-player',
  templateUrl: './video-player.component.html',
  styleUrls: ['./video-player.component.scss']
})
export class VideoPlayerComponent implements OnInit, AfterViewInit {
  @Input() videoId: number;
  @ViewChild('videoPlayerContainer', { static: true }) videoPlayerContainer: ElementRef;

  videoUrl
  isError: boolean = false;

  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    this.isError = false;
 
    const player = new Player(this.videoPlayerContainer.nativeElement, { id: this.videoId, width: '640px' });

    player.play().then(() => {
    }).catch((error) => {
      this.isError = true;
    })
  }

}
